import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetaSettings } from '../../firebase/database';
import { initPixel, trackPageView } from '../../utils/pixel';

// Mounted once near the root of the app. Loads the Pixel ID saved in
// Admin → Meta settings, initializes the real Facebook Pixel, and fires
// a PageView event on every route change.
const PixelManager = () => {
  const location = useLocation();
  const loadedRef = useRef(false);

  useEffect(() => {
    getMetaSettings()
      .then((s) => {
        if (s?.enabled && s?.pixelId) {
          initPixel(s.pixelId);
          loadedRef.current = true;
          trackPageView();
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (loadedRef.current) trackPageView();
  }, [location.pathname]);

  return null;
};

export default PixelManager;
